module.exports = __webpack_public_path__ + "img/add.ab9e2c50.svg";